<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('messageList.msgTitle')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('messageList.read')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('messageList.readStatus.1')" :value="1"></el-option>
								<el-option :label="$t('messageList.readStatus.2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
		
						<el-form-item :label="$t('messageList.time')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>

                        
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('messageList.readAll')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
                <el-table-column align="center" prop="title" width="100" :label="$t('messageList.msgTitle')">
				</el-table-column>
                <el-table-column align="center" prop="content" :label="$t('messageList.msgCon')">
                    <template slot-scope="scope">
									<div v-if="scope.row.content.length > 20">
                                        <div v-html="scope.row.content.substring(0, 20)"></div>
									</div>
									<div v-else>
                                        <div v-if="scope.row.content.length > 0" v-html="scope.row.content.substring(0, 20)"></div>
										<div v-else> -- </div>
									</div>
								</template>
				</el-table-column>
				
                <el-table-column align="center" prop="is_read" width="100" :label="$t('messageList.read')">
                    <template slot-scope="scope">
						<span v-if="scope.row.is_read == 1" class="text-success">{{$t('messageList.readStatus.1') }}</span>
						<span v-if="scope.row.is_read == 2" class="text-danger">{{$t('messageList.readStatus.2') }}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="190" :label="$t('messageList.time')">
				</el-table-column>
				<el-table-column prop="id" align="center"  width="100" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini"  plain type="primary" v-auth="'editAdmin'" @click="cancelModel(scope.row)">{{$t('system.look')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>
        
        <el-dialog :close-on-click-modal="false"
			:title="$t('messageList.msgCon')"
			:visible.sync="dialogVisible"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="closeDialog"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
                <span slot="title">
                    <span style="font-size: 2em;">{{ dialogTitle }}</span>
                </span>
                <div ref="dialogContent" style="max-height: 70vh; overflow: auto;">
                    <!-- 使用 v-html 渲染 HTML 内容 -->
                    <div v-html="dialogContent"></div>
                </div>
               

			<div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">{{$t('system.cancel')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {

				dialogContent:'',
				dialogTitle:'',

				dialogTitleVisible: false,
				fullTitle: '',

                dialogVisible: false,

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name:'',
                    status:-1,
					time:[],
				},
				auth_val: 'Apply',

                prop: 'id',
                sort: 'descending',

				preUrl: "data/messageList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				// delUrl: "user/delApply", //删除單条地址
				// addUrl: "user/addApply", //添加/修改地址
				editStatusUrl:"user/editStatusApply",//修改狀態地址

				pay_info: [],

				tableData: [],
				form: {
                    money: "",
				},
				rules: {
					money: [
                        {
                            required: true,
                            message: this.$t('messageList.applyMoney'),
                            trigger: 'blur'
                        },
                        {
                            validator: (rule, value, callback) => {
                            if (value <= 0) {
                                callback(new Error(this.$t('messageList.applyMoney')))
                            } else {
                                callback()
                            }
                            },
                            trigger: ['blur', 'change']
                        }
                    ]
				},
				Apply_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			// this.commonList(['Apply']);
		},
		methods: {
            closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
            hidePayModel() {
            	// 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
				this.editIndex = -1
                this.createModel = false
                this.payInfoModel = false
				this.getList()
            },
			   // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},

            cancelModel(row){
                this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				this.dialogTitle = row.title; // 设置要顯示的 HTML 内容
                this.dialogVisible = true
				
				if(row.is_read==2){
					// 添加确认对话框
					this.axios.post('/admin/data/editStatusMsg', {
						id: row.id,
					    type:1,
					}, {
						token: true
					}).then(res => {
						let all = res.data
						this.getList()
						this.layout.getPageNum()
					}).catch(err => {
					
					})
				}
				
            },
            // 打开模态框
			openModel() {
                this.$confirm(
					this.$t('messageList.cancelConfirm'), // 确认提示内容
					this.$t('messageList.confirmTitle'),  // 对话框标题
					{
						confirmButtonText: this.$t('system.confirm'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}
				).then(() => {
					// 用户确认后执行原逻辑
					this.layout.loading = true;
					this.axios.post('/admin/data/editStatusMsg', {
						id: [],
                        type:2,
					}, {
						token: true
					}).then(res => {
						let all = res.data
						if (all.code == 1) {
							this.$message({
								message: all.msg,
								type: 'success'
							}); // 控制是否顯示成功提示
						}
						this.layout.loading = false;
						this.loading = false;
						this.getList()
						this.layout.getPageNum()
					}).catch(err => {
						this.layout.loading = false;
					})
				}).catch(() => {
					// 用户取消时可选操作
					this.$message({
						type: 'info',
						message: this.$t('message.cancelOperate')
					});
				});
			},
			hide(){
                // 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
					this.editIndex = -1
                    this.createModel = false
            },
            copyAddress() {
                // 实现复制地址逻辑
                navigator.clipboard.writeText(this.pay_info.trc)
            },
			
			//公共列表
			// commonList(type) {
			// 	this.layout.loading = true;
			// 	this.axios.post('/admin/user/commonList', {
			// 		type: type,
			// 	}, {
			// 		token: true,
			// 	}).then(res => {
			// 		let all = res.data
			// 		let list = all.data.list
			// 		this.Apply_list = list.Apply

			// 		this.layout.loading = false;
			// 	}).catch(err => {
			// 		// 失敗
			// 		this.layout.loading = false;
			// 	})
			// },
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name:'',
					status:-1,
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>
<style lang="scss"> /* 使用 SCSS/SASS 预处理器 */
    .recharge-form {
  .el-form-item__label {
    font-weight: bold;
  }

  .address-input {
    .el-input__inner {
      font-family: monospace; /* 更适合地址显示 */
    }
  }

  .qrcode-container {
    text-align: center;
    margin: 0 auto;
    
    .qrcode-image {
      width: 200px;
      height: 200px;
      border: 1px solid #eee;
      padding: 10px;
      border-radius: 4px;
      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
      }
    }

    .qrcode-placeholder {
      width: 200px;
      height: 200px;
      background: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      margin: 0 auto;
    }

    .qrcode-tip {
      color: #666;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>

